import { useState, useCallback, ChangeEvent, KeyboardEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import { useMutation } from '@apollo/client';

import * as A from '@pages/Auth/Auth.style';
import theme from '@styles/theme';
import useEnter from '@hooks/useEnter';
import { onlyNumber } from '@utils/common';
// import { Mutation } from '@graphql/types';
// import { FIND_ADMIN_ACCOUNT } from '@graphql/mutations';
import { validateFindEmail } from '@utils/validation';

import StyledInput from '@components/styled/StyledInput';
import StyledButton from '@components/styled/StyledButton';

const FindEmail = () => {
    const navigate = useNavigate();
    const onEnter = useEnter();
    const { pathname } = useLocation();
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<string[] | null>(null);
    const [inputs, setInputs] = useState({
        license: '',
        cellphone: '',
        name: ''
    });

    // const [findAdminAccount] =
    //     useMutation<Pick<Mutation, 'findAdminAccount'>>(FIND_ADMIN_ACCOUNT);

    const onChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const { name, value } = e.target;
            if (name !== 'name') {
                return setInputs({
                    ...inputs,
                    [name]: onlyNumber(value)
                });
            }
            setInputs({
                ...inputs,
                [name]: value
            });
        },
        [inputs]
    );

    const handleSubmit = async () => {
        if (!validateFindEmail(inputs)) return;

        setLoading(true);

        try {
            setResult(['example@platcube.com']);
            // await findAdminAccount({
            //     variables: {
            //         name,
            //         cellphone
            //     },
            //     onCompleted: (data) => {
            //         setResult(data.findAdminAccount as string[]);
            //     }
            // });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <A.Wrapper>
            <A.Title>이메일을 잊으셨나요?</A.Title>
            <A.SubTitle>
                등록된 요양기관 번호와 대표자명을 입력해주세요
            </A.SubTitle>
            <StyledInput
                value={inputs.license}
                name="license"
                onChange={onChange}
                placeholder="요양기관번호를 입력해주세요"
                maxLength={8}
                margin="0 0 8px"
                borderRadius={0}
            />
            <StyledInput
                value={inputs.name}
                name="name"
                onChange={onChange}
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) =>
                    onEnter(e, handleSubmit)
                }
                placeholder="대표자명을 입력해주세요"
                maxLength={13}
                borderRadius={0}
            />
            <StyledButton
                title="찾기"
                margin="32px 0"
                width={343}
                fontSize={14}
                fontFamily="PretendardRegular"
                onClick={handleSubmit}
                borderRadius={0}
                bgColor={theme.colors.pointBlue}
                loading={loading}
            />
            {result && (
                <A.SearchArea>
                    <A.SearchText>검색결과</A.SearchText>
                    {!result.length ? (
                        <A.Empty>검색 결과가 존재하지 않습니다.</A.Empty>
                    ) : (
                        <>
                            <A.Result>{result[0]}</A.Result>
                            <StyledButton
                                title="로그인하러 가기"
                                margin="32px 0"
                                width={343}
                                fontSize={14}
                                fontFamily="PretendardRegular"
                                fontColor={theme.colors.blackColor}
                                bgColor={theme.colors.whiteColor}
                                border={`${theme.colors.ultraLightGrayBorder} 1px solid`}
                                onClick={() =>
                                    navigate('/auth/login', {
                                        replace: true
                                    })
                                }
                                borderRadius={0}
                            />
                        </>
                    )}
                </A.SearchArea>
            )}
        </A.Wrapper>
    );
};

export default FindEmail;
